import React from 'react';
import pubSub from 'services/pubSub';
import { backBtnOnClick } from 'components/Header/BackBtn';

const HiddenBackButton = ({ id }) => {
  const handleFocus = () => {
    pubSub.publish('HILITE_CHAMELEON_BACK_BUTTON', { toggle: true });
  };

  const handleBlur = () => {
    pubSub.publish('HILITE_CHAMELEON_BACK_BUTTON', { toggle: false });
  };

  return (
    <button
      id={`hidden-back-button-${id}`}
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        border: 0,
        outline: 0,
        overflow: 'hidden',
      }}
      onClick={backBtnOnClick}
      onFocus={handleFocus}
      onBlur={handleBlur}
      // if aria-label takes precedence. why have content in button then ? hhmmm. . .
      aria-label="Return to previous interaction"
    >
      Go back
    </button>
  );
};

export default HiddenBackButton;
